import Alpine from 'alpinejs';
import axios from '../../config/axios.js';

function createKasirSeasonalThemes() {
  return {
    themes: [],
    loading: false,
    editBase: '',

    init() {
      try {
        const cfg = JSON.parse(this.$el.getAttribute('data-config') || '{}');
        this.editBase = cfg.editBase || '';
      } catch (e) {
        console.error(e);
      }
      this.fetchList();
    },

    editUrl(id) {
      return this.editBase.replace('__ID__', id);
    },

    async fetchList() {
      this.loading = true;
      try {
        const { data } = await axios.get('/api/v1/kasir/engagement/seasonal-themes', { params: { per_page: 50 } });
        this.themes = data.data || [];
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal memuat tema.', 'error');
      } finally {
        this.loading = false;
      }
    },

    formatPeriod(t) {
      if (!t.start_at && !t.end_at) return '—';
      const start = t.start_at ? new Date(t.start_at).toLocaleDateString('id-ID') : '∞';
      const end = t.end_at ? new Date(t.end_at).toLocaleDateString('id-ID') : '∞';
      return `${start} – ${end}`;
    },

    async activate(t) {
      try {
        const { data } = await axios.post(`/api/v1/kasir/engagement/seasonal-themes/${t.id}/activate`);
        Object.assign(t, data.data);
        window.toast?.(data.message || 'Tema diaktifkan.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal mengaktifkan.', 'error');
      }
    },

    async deactivate(t) {
      try {
        const { data } = await axios.post(`/api/v1/kasir/engagement/seasonal-themes/${t.id}/deactivate`);
        Object.assign(t, data.data);
        window.toast?.(data.message || 'Tema dinonaktifkan.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal menonaktifkan.', 'error');
      }
    },

    async remove(t) {
      if (!window.confirm(`Hapus tema "${t.name}"?`)) return;
      try {
        const { data } = await axios.delete(`/api/v1/kasir/engagement/seasonal-themes/${t.id}`);
        this.themes = this.themes.filter((row) => row.id !== t.id);
        window.toast?.(data.message || 'Tema dihapus.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal menghapus.', 'error');
      }
    },
  };
}

Alpine.data('kasirSeasonalThemes', createKasirSeasonalThemes);
